import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Settings} from '../settings/settings';
import {APP_VERSION_LABEL} from '../app-version';

@Injectable({
    providedIn: 'root'
})
export class LoggerService {

    constructor(private http: HttpClient) {

    }

    logError(error) {
        this.sendData(error, APP_VERSION_LABEL);
    }

    /**
     * Logs a structured event to app_logs. The event is stored in the `exception` column as
     * `<CATEGORY> <event> <json>`, so it can be found with `exception LIKE '<CATEGORY> %'`.
     */
    logEvent(category: string, event: string, data: Record<string, unknown> = {}) {
        let payload: string;
        try {
            payload = JSON.stringify(data);
        } catch (e) {
            payload = JSON.stringify({serializeError: String(e)});
        }
        this.sendData(`${category} ${event} ${payload}`, APP_VERSION_LABEL);
    }

    private sendData(error, versionInfo?: any) {
        try {
            this.http.post(`${Settings.API_ENDPOINT}logging/app`, {
                app_version: versionInfo,
                exception: error,
                url: window?.location?.href
            }).pipe(
                catchError(err => {

                    return of([]);
                })
            ).subscribe();
        } catch (e) {

        }
    }
}
